var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Margins',{staticClass:"text-center"},[_c('h4',[_vm._v(" "+_vm._s(_vm.mainMessage)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.secondaryMessage)+" ")]),_c('Button',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('OFFER.BACK_TO_THE_CALCULATOR')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }